/* Delivery promise estimator — fills [data-delivery-promise] with a rolling
 * "Bestell bis {cutoff} Uhr – Lieferung bis {Wochentag}, {dd.MM.}" line.
 *
 * All calendar math runs on UTC-anchored date stamps (no local timezone
 * arithmetic); "now" is taken in Europe/Berlin via Intl so the promise is
 * correct regardless of the visitor's timezone and immune to page caching.
 *
 * Rules:
 *  - Handover to DHL on Mon–Fri (Sat optional via data-saturday-handover),
 *    never on closure dates (data-closures: comma/space separated YYYY-MM-DD).
 *  - Order before the cutoff on a handover day → ships that day, else next
 *    handover day.
 *  - Delivery counts transit days over DHL delivery days (Mon–Sat, skipping
 *    Sundays and closure dates).
 */
(function () {
  'use strict';

  function berlinNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      y: parseInt(parts.year, 10),
      m: parseInt(parts.month, 10),
      d: parseInt(parts.day, 10),
      hh: parseInt(parts.hour, 10) % 24,
      mi: parseInt(parts.minute, 10),
    };
  }

  function stamp(y, m, d) { return Date.UTC(y, m - 1, d); }
  function addDays(ms, n) { return ms + n * 86400000; }
  function dow(ms) { return new Date(ms).getUTCDay(); } /* 0=Sun … 6=Sat */
  function iso(ms) {
    var dt = new Date(ms);
    return dt.getUTCFullYear() + '-' +
      String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(dt.getUTCDate()).padStart(2, '0');
  }

  /* Pure — exposed for testing. now = {y,m,d,hh,mi}; cfg = {cutoff:'HH:MM',
     transitDays:int, saturdayHandover:bool, closures:Set<'YYYY-MM-DD'>} */
  function computePromise(now, cfg) {
    var isClosure = function (ms) { return cfg.closures.has(iso(ms)); };
    var isHandoverDay = function (ms) {
      var wd = dow(ms);
      var okDay = (wd >= 1 && wd <= 5) || (wd === 6 && cfg.saturdayHandover);
      return okDay && !isClosure(ms);
    };
    var isDeliveryDay = function (ms) {
      var wd = dow(ms);
      return wd >= 1 && wd <= 6 && !isClosure(ms);
    };

    var cut = cfg.cutoff.split(':');
    var beforeCutoff = now.hh < parseInt(cut[0], 10) ||
      (now.hh === parseInt(cut[0], 10) && now.mi < parseInt(cut[1] || '0', 10));

    var today = stamp(now.y, now.m, now.d);
    var ship = today;
    var shipsToday = beforeCutoff && isHandoverDay(today);
    if (!shipsToday) {
      ship = addDays(ship, 1);
      var guard = 0;
      while (!isHandoverDay(ship) && guard++ < 30) ship = addDays(ship, 1);
    }

    var delivery = ship;
    for (var i = 0; i < cfg.transitDays; i++) {
      delivery = addDays(delivery, 1);
      var g2 = 0;
      while (!isDeliveryDay(delivery) && g2++ < 30) delivery = addDays(delivery, 1);
    }

    return { shipsToday: shipsToday, deliveryMs: delivery };
  }

  function formatGerman(ms) {
    /* de-DE already ends with a trailing dot after the month ("Mittwoch, 22.07.") */
    return new Intl.DateTimeFormat('de-DE', {
      timeZone: 'UTC', weekday: 'long', day: '2-digit', month: '2-digit',
    }).format(new Date(ms));
  }

  function init() {
    var els = document.querySelectorAll('[data-delivery-promise]');
    if (!els.length) return;
    els.forEach(function (el) {
      try {
        var closures = new Set(
          (el.getAttribute('data-closures') || '')
            .split(/[\s,]+/).filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); })
        );
        var cfg = {
          cutoff: el.getAttribute('data-cutoff') || '12:00',
          transitDays: parseInt(el.getAttribute('data-transit-days'), 10) || 2,
          saturdayHandover: el.getAttribute('data-saturday-handover') === 'true',
          closures: closures,
        };
        var r = computePromise(berlinNow(), cfg);
        var dateStr = formatGerman(r.deliveryMs);
        el.textContent = r.shipsToday
          ? 'Bestell bis ' + cfg.cutoff + ' Uhr – Lieferung bis ' + dateStr
          : 'Lieferung bis ' + dateStr;
        el.hidden = false;
      } catch (e) {
        /* estimator must never break the buy box — stay hidden on any error */
      }
    });
  }

  if (typeof window !== 'undefined') {
    window.DeliveryPromise = { computePromise: computePromise, _iso: iso, init: init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();
